import PropTypes from 'prop-types'
import React from 'react'

import { ContainerTopColumnBagdgeAndSwitch } from '../../styled-components'

import SwitchComponent from '../../../../atoms/switch'
import { switchSizeOptions } from '../../../../atoms/switch/constants'
import BadgesComponent from '../../../../atoms/badges'
import {
  badgeColorOptions,
  badgeSizeOptions,
  badgesVariantOptions
} from '../../../../atoms/badges/constants'

import { IsLoading } from '../list-items-item'
import { listItemStateVariantOptions } from '../../constants'

const CenterContainerBadgesAndSwitch = ({
  badgeValue,
  badgesColor,
  switchIsShow,
  switchIsChecked,
  onChangeSwitch,
  state
}) => {
  if (!badgeValue && !switchIsShow) return null

  return (
    <ContainerTopColumnBagdgeAndSwitch>
      {badgeValue && (
        <IsLoading
          skeletonStyle={{ width: '65px', height: '18px', radius: '4px' }}
        >
          <BadgesComponent
            variant={badgesVariantOptions.STRONG}
            size={badgeSizeOptions.SMALL}
            color={badgesColor || badgeColorOptions.RED}
            disabled={state === listItemStateVariantOptions.INACTIVE}
          >
            {badgeValue}
          </BadgesComponent>
        </IsLoading>
      )}
      {switchIsShow && (
        <IsLoading
          skeletonStyle={{
            width: '42px',
            height: '24px',
            borderRadius: '50px'
          }}
        >
          <SwitchComponent
            size={switchSizeOptions.SMALL}
            defaultChecked={false}
            checked={switchIsChecked}
            onCheckedChange={onChangeSwitch}
            disabled={state === listItemStateVariantOptions.INACTIVE}
          />
        </IsLoading>
      )}
    </ContainerTopColumnBagdgeAndSwitch>
  )
}

CenterContainerBadgesAndSwitch.propTypes = {
  state: PropTypes.oneOf(Object.values(listItemStateVariantOptions)),
  badgeValue: PropTypes.string,
  badgesColor: PropTypes.oneOf(badgeColorOptions),
  switchIsShow: PropTypes.bool,
  switchIsChecked: PropTypes.bool,
  onChangeSwitch: PropTypes.func
}

export default CenterContainerBadgesAndSwitch
